module.exports = __webpack_public_path__ + "static/mail_163-d472f9ebdf2b76b6e902f71dd9a75bc3.png";